<div id="wrapper">
  <div id="page-wrapper" class="gray-bg">
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row" style="padding: 8px 24px;">
        @if (showMasterDataCard) {
          <div class="col-lg-4">
            <mat-card style="cursor: pointer;" routerLink="/Stammdaten" routerLinkActive="active">
              <mat-card-header class="mat-card-header-orange">
                <mat-icon mat-card-avatar>account_box</mat-icon>
                <mat-card-title>{{'Startseite.Stammdaten' | translate}}</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <p style="margin: 12px;">{{'Startseite.Stammdatentext' | translate}}</p>
              </mat-card-content>
            </mat-card>
          </div>
        }

        @if (hasQuestions) {
          <div class="col-lg-4">
            <mat-card>
              <mat-card-header fxLayout="row">
                <mat-icon mat-card-avatar>live_help</mat-icon>
                <mat-card-title>{{'Startseite.Rückfragen' | translate}} ({{questionCount}})
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div style="overflow-y: scroll; height: 400px; padding: 2px">
                  @for (question of this.questions; track question.Id) {
                    <div>
                      <div class="col-xs-12 outline-question" (click)="selectQuestion($event,question)"
                        style="cursor: pointer;">
                        <div><strong>{{question.FrageString}}</strong></div>
                        <div>{{'Frist' | translate}}: {{question.Frist}}</div>
                        <div>{{'Startseite.Dossierinfo' | translate}}: <a style="color:blue" Id="dossier"
                        (click)="this.tryOpenCase(question?.Entity)">{{question.DossierNr}}</a></div>
                        <div>{{question.ArtString}}</div>
                      </div>
                    </div>
                  }
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        }

        @if (hasTasks) {
          <div class="col-lg-4">
            <mat-card>
              <mat-card-header fxLayout="row">
                <mat-icon mat-card-avatar>check_circle</mat-icon>
                <mat-card-title>{{'Startseite.Aufgaben' | translate}} ({{taskCount}})
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div style="overflow-y: scroll; height: 400px; padding: 2px">
                  @for (task of this.tasks; track task.Id) {
                    <div>
                      <div class="col-xs-12 outline-question" (click)="selectTask($event,task)" style="cursor: pointer;">
                        <div><strong>{{task.AufgabeString}}</strong></div>
                        <div>{{'Frist' | translate}}: {{task.Frist}}</div>
                        <div>{{'Startseite.Dossierinfo' | translate}}: <a style="color:blue" Id="dossier"
                        (click)="this.tryOpenCase(task?.Entity)">{{task.DossierNr}}</a></div>
                        <div>{{task.ArtString}}</div>
                        @if (task.Erledigt) {
                          <mat-icon class="mat-icon-done">done</mat-icon>
                        }
                      </div>
                    </div>
                  }
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        }

        <div class="col-lg-4">
          <mat-card>
            <mat-card-header>
              <mat-icon mat-card-avatar>date_range</mat-icon>
              <mat-card-title>{{'Startseite.Abwesenheiten' | translate}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <table mat-table [dataSource]="absences" style="width: 100%;">

                <!-- Von Column -->
                <ng-container matColumnDef="Von">
                  <mat-header-cell *matHeaderCellDef>{{'Von' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.Von}} </mat-cell>
                </ng-container>

                <!-- Bis Column -->
                <ng-container matColumnDef="Bis">
                  <mat-header-cell *matHeaderCellDef>{{'Bis' | translate}}</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{element.Bis}}</mat-cell>
                </ng-container>

                <!-- Icons Column -->
                <ng-container matColumnDef="Plus">
                  <mat-header-cell *matHeaderCellDef>
                    <mat-icon class="clickable-icon" (click)="editAbsence(null)" style="color: gray;"
                    matTooltip="{{'Startseite.Hinzufügen' | translate}}">add_circle</mat-icon>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-icon class="clickable-icon" (click)="editAbsence(element)" style="color: gray;">edit</mat-icon>
                    &nbsp;&nbsp;
                    <mat-icon class="clickable-icon" (click)="openDialogDeleteAbsence(element)" style="color: gray;">delete</mat-icon>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="absenceColumns"></mat-header-row>
                <mat-row *matRowDef="let _; columns: absenceColumns;"></mat-row>
              </table>
            </mat-card-content>
          </mat-card>
        </div>

        <!-- CARD DOSSIER (MESSAGE) -->
        <div class="col-lg-4">
          <mat-card>
            <mat-card-header>
              <mat-icon mat-card-avatar>message</mat-icon>
              <mat-card-title>{{'Startseite.Meldungen' | translate}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div style="padding: 8px;">
                <!-- TODO : schöner -->
                {{'Startseite.Meldungdossiersauftrag' | translate}}

                <mat-form-field appearance="fill" style="width: 100%; margin-top: 8px;" floatLabel="always">
                  <mat-label>{{'Dossier.Dossiernummer' | translate}} / {{'Dossier.Rechnungsnummer' | translate}}</mat-label>
                  <input matInput [(ngModel)]="caseSearch" style="margin: 0px" autocomplete='off' (keyup.enter)="tryOpenCase()">
                  <mat-icon matSuffix class="clickable-icon" style="color: gray; font-weight: 600;" (click)="tryOpenCase()">search</mat-icon>
                </mat-form-field></div>

            </mat-card-content>
          </mat-card>
        </div>

        <!-- CARD ACCOUNTING -->
        <div class="col-lg-4">
          <mat-card>
            <mat-card-header>
              <mat-icon mat-card-avatar>account_balance</mat-icon>
              <mat-card-title>{{'Startseite.Finanzen' | translate}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <table mat-table [dataSource]="accountDataSource" style="width: 100%;">
                <ng-container matColumnDef="Key">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let element" style="padding-right: 12px;">
                  {{element.Key | translate}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Date">
                  <mat-header-cell *matHeaderCellDef>{{'Startseite.Datum' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{element.Date}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Value">
                  <mat-header-cell *matHeaderCellDef>{{'Startseite.Betrag' | translate}}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{element.Value}}</mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="accountColumns"></mat-header-row>
                <mat-row *matRowDef="let _; columns: accountColumns;"></mat-row>
              </table>

              <div style="margin: 16px 8px 8px 8px">
                <a routerLink="/Kundenkonto">{{'Kundenkonto.KundenkontoLink' | translate}}</a>
              </div>

            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
